import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createTimeSheet } from "../actions/createTimeSheet.actions";
import { timeSheetsQueryKeys } from "../queries/timeSheets.queries";
import { useGlobalSnackbar } from "../../../context/SnackbarContext";
import { updateTimeSheets } from "../actions/updateTImeSheets.actions";

export const useTimeSheetMutation = () => {
  const { showSnackbar } = useGlobalSnackbar();
  const queryClient = useQueryClient();

  const createTimeSheetMutation = useMutation({
    mutationFn: createTimeSheet,

    onSuccess: () => {
      showSnackbar("Time sheet created successfully", "success");

      queryClient.invalidateQueries({
        queryKey: timeSheetsQueryKeys.all,
      });

      queryClient.invalidateQueries({
        queryKey: ["job-events"],
      });
    },

    onError: (error) => {
      showSnackbar(error.message, "error");
    },
  });

  const updateTimeSheetMutation = useMutation({
    mutationFn: updateTimeSheets,

    onSuccess: () => {
      showSnackbar("Time sheet updated successfully", "success");

      queryClient.invalidateQueries({
        queryKey: timeSheetsQueryKeys.all,
      });

      queryClient.invalidateQueries({
        queryKey: ["job-events"],
      });
    },

    onError: (error) => {
      showSnackbar(error.message, "error");
    },
  });

  return {
    createTimeSheetMutation,
    updateTimeSheetMutation,
  };
};
